import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';

import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import { useHistory } from 'react-router-dom';
import { getEventByName } from './utils';
import { useHorsesStore } from '../../../stores/horses'
import dayjs from 'dayjs';
import { FilledBtn, StyledIcon, SubTitle, Title, VisitTitle } from './styles';

import Button from '@mui/material/Button';
import { Container } from '@mui/material';
interface IHorseVisit {
    horse_id: number | string, last_visit: Date | string | number, reminder_date: Date | string | number, notes: string, event_type: number | string, _ID?: string
}
export interface RecordsProps {
    title: string;
    profileId?: string;
    subTitle?: string;
    visits?: IHorseVisit[]
    onClick: (id: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any) => void
    onAddVisit?: (id: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any, visitId?: string) => void
    onEditClick?: (visitId: string, title: string, subtitle?: string, actionTitle?: string, noReminder?: boolean, config?: any) => void
    config?: any
    color: string
    noReminder?: boolean

}
const Records: FunctionComponent<RecordsProps> = (props) => {
    const route = useHistory()
    const store = useHorsesStore()
    const visitClick = (params: { title: string, event_type: number, _ID?: string }) => {
        route.push('/visit', params)
    }
    const color = useMemo(() => {
        return props.color == '#f4f4f4' ? '#000' : '#fff'
    }, [])
    const Dividerstyle = {

        borderColor: color
    };
    const DateIconStyle = {
        width: 30,
        height: 30,
        color: color,
    }


    return <div style={{ backgroundColor: props.color, width: '100%' }}>
        <ResRecordsWrapper color={props.color}>
            <Stack direction="column" justifyContent="center" alignItems="flex-start" sx={{ width: '100%' }}>
                <Accordion defaultExpanded={false} square disableGutters={true} sx={{
                    backgroundColor: 'transparent !important',
                    boxShadow: 'none !important',
                    border: '0 !important',
                    position: 'initial !important',
                    width: '100%'
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: color }} fontSize="large" />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <VisitTitle color={color}>{props.config.renameTitle ? props.config.renameTitle : `${props.title} Records:`}</VisitTitle>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SubTitle color={color} >{props.subTitle ? props.subTitle : `Past ${props.title} Visits:`}</SubTitle>
                        <Divider flexItem sx={Dividerstyle} />


                        {props.visits ? props.visits.map(item => {
                            return <Stack sx={{
                                flexDirection: {
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row'
                                }
                            }} alignItems="center" justifyContent="flex-start" paddingTop={'20px'} paddingBottom={'20px'} width={'100%'}>
                                <QueryBuilderIcon style={DateIconStyle} />
                                <DateFont color={color}>{props.config.showNotes == true ? item.notes : dayjs(item.last_visit).format('ddd,MMM D,YYYY') as string}</DateFont>
                                <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginLeft: { xs: 'inherit', sm: 'auto' } }}>
                                    <ActionBtn variant="contained" size='small' sx={{ color: props.color == '#f4f4f4' ? 'white !important' : ' #408697 !important', background: props.color == '#f4f4f4' ? '#408697 !important' : '#fff !important' }}
                                        onClick={() => props.onClick(item._ID!, props.title, props.config.subtitle, props.config.renameAction, props.noReminder, props.config)}
                                    >
                                        View
                                    </ActionBtn>
                                    {store.isEditingMode == true && <>
                                        <ActionBtn
                                            variant="outlined"
                                            size='small'
                                            sx={{ color: props.color == '#f4f4f4' ? 'black !important' : ' #fff !important', background: 'transparent !important', border: '1px solid !important' }}
                                            onClick={() => {
                                                if (props.onEditClick && item._ID) {
                                                    props.onEditClick(item._ID, props.title, props.config.subtitle, props.config.renameAction, props.noReminder, props.config)
                                                }
                                            }}
                                        >
                                            Edit
                                        </ActionBtn>
                                        <ActionBtn variant="contained" color="error" size='small' sx={{ color: ' #fff !important', background: '#f10000 !important' }} onClick={() => store.delete(item._ID!)}>
                                            Delete
                                        </ActionBtn>
                                    </>}
                                </Stack>

                            </Stack>
                        })
                            :
                            <Stack direction="row" alignItems="center" justifyContent="center" paddingTop={'20px'} paddingBottom={'20px'}>
                                <QueryBuilderIcon style={DateIconStyle} />
                                <DateFont color='#fff'>{'No Visit'}</DateFont>
                            </Stack>

                        }

                        {store.isEditingMode == true && <>
                            <Divider flexItem sx={Dividerstyle} />
                            {/* <AddBtn variant="text" startIcon={<AddCircleIcon style={{ marginLeft: "2px" }} />} onClick={() => visitClick({
                    title: props.title,
                    event_type: Number(getEventByName({ name: props.title })),
                    _ID: props.profileId
                })}>
                    {props.config?.renameAction ? props.config?.renameAction : 'Add Visit'}
                </AddBtn> */}
                            {props.color == '#f4f4f4' ? <AddBtnWhite variant="text" startIcon={<AddCircleIcon style={{ marginLeft: "2px" }} />} onClick={() => {
                                if (props.profileId && props.onAddVisit) {
                                    props.onAddVisit(props.profileId, props.title, props.config.subtitle, props.config.renameAction, props.noReminder, props.config)
                                }

                            }}>
                                {props.config?.renameAction ? props.config?.renameAction : 'Add Visit'}
                            </AddBtnWhite>
                                : <AddBtnBlue variant="text" startIcon={<AddCircleIcon style={{ marginLeft: "2px" }} />} onClick={() => {
                                    if (props.profileId && props.onAddVisit) {
                                        props.onAddVisit(props.profileId, props.title, props.config.subtitle, props.config.renameAction, props.noReminder, props.config)
                                    }

                                }}>
                                    {props.config?.renameAction ? props.config?.renameAction : 'Add Visit'}
                                </AddBtnBlue>}

                        </>}
                    </AccordionDetails>


                </Accordion>

            </Stack>

        </ResRecordsWrapper ></div>
}


const ActionBtn = styled(FilledBtn)`
    margin-left: auto;
    height: 30px !important;
    width: 100px !important;
    margin:0 10px !important;
    font-size: 10px !important;
    font-family: sans-serif;
    padding: 0;
`


const DateFont = styled(Title)`
    font-size: 18px;
    font-family: system-ui;
    font-weight: 900;
`




const StyledRecordsWrapper = styled(Container)`
    display:flex;
    flex:1;
    background-color:${props => props.color};
    padding:80px;
    justify-content: center;
    align-items:flex-start;
    flex-basis:50%;
    max-width:1200px;
`
const ResRecordsWrapper = styled(StyledRecordsWrapper)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        padding: '20px',
    },
}));

const AddBtnBlue = styled(FilledBtn)`
    justify-content: flex-start !important;
    font-size: 20px !important;
    padding:0 !important;
    margin-top:20px !important;
    margin-bottom:20px !important;
`
const AddBtnWhite = styled(Button)`
    justify-content: flex-start !important;
    text-transform: none !important;
    font-size: 20px !important;
    padding:0 !important;
    margin-top:20px !important;
    margin-bottom:20px !important;
    color:black !important;
    background-color: #f4f4f4 !important;
    font-weight: 900 !important;
    font-family: inherit !important;
`
export default Records
